exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-seo-page-dialog {\n  width: 950px;\n  display: block;\n}\n\n/* =============================================================================\n\n                                    Mobile\n\n============================================================================= */\n@media only screen and (max-width: 768px) {\n  fi-seo-page-dialog {\n    width: 100%;\n  }\n}", ""]);

// exports
